import React, { useState, useEffect } from "react";
import { useLanguage } from "../LanguageContext";

const Navigation: React.FC = () => {
    const { t, toggleLang } = useLanguage();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [menuOpen]);

    const close = () => setMenuOpen(false);

    return (
        <nav className={`navigation${scrolled ? " scrolled" : ""}`}>
            <div className="nav-inner">
                <a href="#top" className="nav-brand">
                    <span className="nav-brand-text">SYSLOGICS</span>
                </a>

                <div className={`nav-links${menuOpen ? " open" : ""}`}>
                    <a href="#about"    onClick={close}>{t.nav.about}</a>
                    <a href="#services" onClick={close}>{t.nav.services}</a>
                    <a href="#partners" onClick={close}>{t.nav.partners}</a>
                    <a href="#contact"  onClick={close} className="nav-cta">{t.nav.contact}</a>
                    <button className="lang-toggle" onClick={() => { toggleLang(); close(); }}>
                        {t.nav.langSwitch}
                    </button>
                </div>

                <div className="nav-right">
                    <button className="lang-toggle lang-toggle-desktop" onClick={toggleLang}>
                        {t.nav.langSwitch}
                    </button>
                    <button
                        className="nav-menu-btn"
                        onClick={() => setMenuOpen(v => !v)}
                        aria-label="Toggle menu"
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;
